// 🟢 خريطة الأيقونات
import { FaExchangeAlt, FaMoneyBillWave, FaUserFriends } from "react-icons/fa";

// 🟢 ترجمة العناوين
export const translations = {
  total_transactions: "إجمالي العمليات",
  total_volume: "إجمالي المبالغ",
  active_users: "التجار النشطين",
};

export const iconsMap = {
  total_transactions: <FaExchangeAlt />,
  total_volume: <FaMoneyBillWave />,
  active_users: <FaUserFriends />,
};


